// import artiste1 from "../../assets/artiste1.svg";
// import banjo from "../../assets/banjo.png";
// import musician from "../../assets/musician.jpg";
// import lady from "../../assets/lady.jpg";
// import cat from "../../assets/cat.png";
import stickyup from "../../assets/stickyup.png";
import dami from "../../assets/dami.JPEG";
import uk from "../../assets/uk.png";
import nja from "../../assets/nigeria.png";
import canada from "../../assets/canada.png";
import Sivante from "../../assets/Sivante.jpeg";
import uti from "../../assets/uti.png";

export const artisteData = [
  {
    id: 1,
    artisteName: "Stickup Boys",
    intro: "Stickup Boys is boy band based in the UK.",
    img: stickyup,
    twitterLink: "https://twitter.com/Stickupmusic",
    tiktokLink: "https://www.tiktok.com/@stickupboys",
    instaLink: "https://www.instagram.com/stickupboysuk/",
    country: uk,
  },
  {
    id: 2,
    artisteName: "S O B",
    intro: "Dami is an indegenous rapper currently based in Nigeria ",
    img: dami,
    twitterLink: "https://twitter.com/i_amSOB",
    tiktokLink: "https://www.tiktok.com/@sadexsob",
    instaLink: "https://instagram.com/sadex_sob?igshid=YmMyMTA2M2Y=",
    country: nja,
  },
  {
    id: 3,
    artisteName: "Rok Sivante",
    intro:
      "Rok Sivante is a sound producer currently based in currently based in Alberta ",
    img: Sivante,
    twitterLink: "https://twitter.com/bullchord",
    tiktokLink: "https://www.tiktok.com/@utigreg?_t=8bA7lJJdRmX&_r=1",
    instaLink: "https://www.instagram.com/rok.sivante/",
    country: canada,
  },
  {
    id: 4,
    artisteName: "Uti Greg",
    intro: "Uti Greg is a rapper currently based in Nigeria ",
    img: uti,
    twitterLink: "https://twitter.com/bullchord",
    tiktokLink: "https://www.tiktok.com/@utigreg?_t=8bA7lJJdRmX&_r=1",
    instaLink: "https://instagram.com/uti.greg?igshid=YmMyMTA2M2Y=",
    country: nja,
  },
 
];
